import React from "react"
import CustomTextInput from "../../../../../ui/atoms/CustomTextInput"
import CheckboxFilterItem from "../CheckboxFilterItem"
import { FacetOption } from "../types"

interface Props {
  options: FacetOption[]
  onOptionToggle: (item: FacetOption, newValue: boolean) => void
  className?: string
  maxScrollItems?: number
  minTextFilterItems?: number
}

const filterOptions = (options: FacetOption[], text: string) =>
  options
    .filter((x) => !x.disabled)
    .filter((x) => x.label.toLowerCase().indexOf(text.toLowerCase()) >= 0)

const CheckboxFilterCategory = ({
  options,
  onOptionToggle,
  className,
  maxScrollItems,
  minTextFilterItems,
}: Props) => {
  const [text, setText] = React.useState("")

  return (
    <div className={className}>
      {minTextFilterItems && options.length >= minTextFilterItems && (
        <div className="mb-2">
          <CustomTextInput value={text} onChange={setText} label="Filtra" />
        </div>
      )}
      <div
        style={{
          maxHeight: maxScrollItems ? maxScrollItems * 36 : undefined,
          overflow: "auto",
        }}
      >
        {filterOptions(options, text).map((option: FacetOption) => (
          <div key={option.label}>
            <CheckboxFilterItem
              count={option.count}
              label={option.label}
              selected={option.selected}
              onClick={() => onOptionToggle(option, !option.selected)}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default CheckboxFilterCategory
